import { Spinner } from "@/components/ui/spinner";
import { loginPath } from "@/constants";
import { shopifyCallback } from "@/hooks/shopify-mutation";
import { useAuth } from "@/providers/auth";
import { useOrg } from "@/providers/organization";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/auth/shopify/callback")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const { getToken } = useAuth();
  const { orgId, storeOrg } = useOrg();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    // Get URL parameters from current location
    const urlParams = new URLSearchParams(window.location.search);
    const shop = urlParams.get("shop");
    const hmac = urlParams.get("hmac");
    const host = urlParams.get("host");
    const state = urlParams.get("state");
    const code = urlParams.get("code");
    const timestamp = urlParams.get("timestamp");

    // Validate required parameters
    if (!shop || !hmac || !host || !timestamp || !state || !code) {
      console.error("Missing required Shopify auth parameters");
      window.location.href = loginPath;
      return;
    }

    // Call the async function
    shopifyCallback(urlParams.toString(), getToken, orgId, navigate, storeOrg);
  }, [getToken, navigate, orgId, storeOrg]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
        <div className="flex flex-col items-center space-y-4">
          <Spinner className="size-8" />
          <p>{t("auth.connectingShopify")}</p>
        </div>
      </div>
    </div>
  );
}
